import React from 'react';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Typography from '@material-ui/core/Typography';

import {SetRowsPerPage} from '@pluto/table';
import MediaOrderImportValidations from './MediaOrderImportValidations';
import MediaOrderImportProvider from './MediaOrderImportProvider';
import {
    MediaOrderValidationItem,
    OnModalTrigger,
    HandleFileSubmit,
} from '../MediaOrdersTypes';
import './MediaOrderImport.scss';

interface MediaOrderImportProps {
    handleOpen: OnModalTrigger;
    handleClose: OnModalTrigger;
    handleSubmit: HandleFileSubmit;
    isLoading: boolean;
    handlePopupClose: OnModalTrigger;
    validations: MediaOrderValidationItem[];
    isValidationsVisible: boolean;
    rowsPerPage: number;
    setRowsPerPage: SetRowsPerPage;
    open: boolean;
}

export default function MediaOrderImport(props: MediaOrderImportProps) {
    const {
        handleClose,
        handleOpen,
        handleSubmit,
        isLoading,
        validations,
        handlePopupClose,
        isValidationsVisible,
        rowsPerPage,
        setRowsPerPage,
        open,
    } = props;

    const backdrop = {
        timeout: 500,
    };
    return (
        <Box className="media-order-import">
            <Button onClick={handleOpen} variant="outlined" color="primary">
                Import Media Order
            </Button>
            <Modal
                aria-labelledby="transition-modal-title"
                className="media-order-import__modal"
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={backdrop}
            >
                <Fade in={open}>
                    <Container className="media-order-import__modal-container">
                        <Typography variant="h5" id="transition-modal-title">
                            Import media order
                        </Typography>
                        <MediaOrderImportProvider
                            handleClose={handleClose}
                            isLoading={isLoading}
                            handleSubmit={handleSubmit}
                        />
                    </Container>
                </Fade>
            </Modal>
            <MediaOrderImportValidations
                validations={validations}
                handleClose={handlePopupClose}
                open={isValidationsVisible}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
            />
        </Box>
    );
}
